var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"align-middle d-inline-flex d-flex-row",attrs:{"for":_vm.title}},[_c('span',[_vm._v(_vm._s(_vm.title))]),(_vm.required)?_c('span',{staticStyle:{"color":"blue"}},[_vm._v("＊")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }